import React, { useState } from "react";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { usePopupState, bindMenu } from "material-ui-popup-state/hooks";

import PositionSlot from "./PositionSlot";

const PositionedFieldsEditor = ({ 
  positionedFields, 
  availableFields, 
  onRemove,
  onAdd 
}) => {
  const [activeAddPosition, setActiveAddPosition] = useState(null);
  const popupState = usePopupState({ variant: "popover", popupId: "add-positioned-field" });

  // Get fields that are not currently used in any position
  const usedFieldIds = Object.values(positionedFields)
    .filter(field => field && field[0])
    .map(field => field[0]);

  const fieldsToAdd = availableFields.filter(
    availableField => !usedFieldIds.includes(availableField[0])
  );

  const handleAddField = (field) => {
    if (activeAddPosition) {
      onAdd(activeAddPosition, field);
      setActiveAddPosition(null);
    }
    popupState.close();
  };

  const handleAddClick = (position) => {
    setActiveAddPosition(position);
    popupState.open();
  };

  const handleRemove = (position) => {
    onRemove(position);
  };

  return (
    <Box sx={{ mt: 2 }}>
            <PositionSlot
        position="1"
        label="Position 1:"
        field={positionedFields.position_1}
        onRemove={handleRemove}
        onAddClick={handleAddClick}
        availableFields={fieldsToAdd}
      />
      
      <PositionSlot
        position="2"
        label="Position 2:"
        field={positionedFields.position_2}
        onRemove={handleRemove}
        onAddClick={handleAddClick}
        availableFields={fieldsToAdd}
      />
      
      <PositionSlot
        position="3"
        label="Position 3:"
        field={positionedFields.position_3}
        onRemove={handleRemove}
        onAddClick={handleAddClick}
        availableFields={fieldsToAdd}
      />

      <Menu
        {...bindMenu(popupState)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        {fieldsToAdd.map(field => (
          <MenuItem 
            key={field[0]} 
            onClick={() => handleAddField(field)}
            sx={{ minWidth: 200 }}
          >
            {field[2]}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default PositionedFieldsEditor;
